import React from 'react';
import back from "../../images/back.png";
import './back.css';

const Back=(props)=>(
    <a className="back-link">
        <img src={back} alt={'Back'} style={{background:'transparent'}} onClick={props.onPrevious} />
    </a>
);
export default Back;